import React from "react";
import PropTypes from 'prop-types';
import { Button } from 'antd';
import _ from 'lodash';
import NotificationModule from 'modules/notification';

class NotificationItem extends React.PureComponent {
  renderHeader = () => {
    const { families, id, onRemove, familyId } = this.props;
    return (
      <div className='notificationItemHeader'>
        <div className='headerName'>
          {_.get(families, `[${familyId}].name`, '-')}
        </div>
        <div className='headerTitle'>
          {_.get(families, `[${familyId}].patient`, '-')}
        </div>
        <div className='headerButton'>
          <Button
            className='closeButton'
            type='primary'
            icon='close'
            size={'small'}
            ghost={true}
            onClick={() => {
              onRemove(id);
            }}>
          </Button>
        </div>
      </div>
    )
  }

  parseNotificationMessage = (message) => {
    const {source} =this.props;
    if (message === 'バッテリー残量が少なくなっています。') {
      return `${source} ${message}`
    }
    return message
  }

  renderMessage = () => {
    const { createdAt, timeNow, notificationText } = this.props;
    const timeStamp = NotificationModule.constructTimeStamp(timeNow, createdAt);
    return (
      <div className='notificationItemMessage'>
        <span className='messageIcon'></span>
        <span className='messageText'>
          {this.parseNotificationMessage(notificationText)}
        </span>
        <span className='messageTime'>
          {` ${timeStamp}`}
        </span>
      </div>
    )
  }

  render() {
    return (
      <div className='component-notificationItem fullContent'>
        {this.renderHeader()}
        {this.renderMessage()}
      </div>
    )
  }
}

NotificationItem.defaultProps = {
  onRemove: null,
};

NotificationItem.propTypes = {
  id: PropTypes.string.isRequired,
  familyId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  read: PropTypes.bool.isRequired,
  createdAt: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  families: PropTypes.object.isRequired,
};

export default NotificationItem;
